import { render } from "./ViewCategorieArticlePage.vue?vue&type=template&id=689b91ca&ts=true"
import script from "./ViewCategorieArticlePage.vue?vue&type=script&lang=ts"
export * from "./ViewCategorieArticlePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__